/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;

    const DATATYPE = feature.getSettingValue('FUNCTIONCODE');
    const DEVICE = feature.getSettingValue('DEVICE');
    let PROTOCOL = 'modbus_RTU';
    let INTERFACE = feature.getSettingValue('SERIAL_PORT');
    const links = project.getNodeLinks(feature, 'modbus_poll');
    if (links.length === 0) {
        return blocks;
    }
    const source = project.getFeature(links[0].getSettingValue('SOURCE_FEATURE')) as BaseNode;
    const sourceParams = source.getPort(links[0].getSettingValue('SOURCE_PORT'))?.params;
    let DEVICEID = project.parseCodeExpression(feature.getSettingValue('DEVICEID'), sourceParams, TibboDataType.BYTE);
    const ADDRESS = project.parseCodeExpression(feature.getSettingValue('REGISTER_ADDRESS'), sourceParams, TibboDataType.WORD);
    const DATA = project.parseCodeExpression(feature.getSettingValue('DATA'), sourceParams, TibboDataType.STRING);

    if (DEVICE !== '') {
        const device = project.getFeature(DEVICE);
        PROTOCOL = device?.getSettingValue('PROTOCOL');
        if (PROTOCOL === 'modbus_TCP') {
            INTERFACE = `${device?.getSettingValue('NAME')}_MODBUS_SOCK_NUM`;
            const DEVICEIP = device?.getSettingValue('DEVICEIP');
            const DEVICEPORT = device?.getSettingValue('DEVICEPORT');
            DEVICEID = `"${DEVICEIP}:${DEVICEPORT}"`;
        } else {
            const feature = project.getFeature(device?.getSettingValue('SERIAL_PORT'));
            if (feature) {
                INTERFACE = `SER_${feature.getSettingValue('NAME')}`;
            }
            DEVICEID = device?.getSettingValue('DEVICEID');
        }
    } else if (PROTOCOL === 'modbus_RTU') {
        const featureSerialPort = project.getFeature(feature.getSettingValue('SERIAL_PORT'));
        if (featureSerialPort) {
            INTERFACE = `SER_${featureSerialPort.getSettingValue('NAME')}`;
        }
    }


    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';

    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
modbus_master_request(${DEVICEID}, ${DATATYPE}, ${ADDRESS},${DATA || '""'})
${doneBlock}
`,
        });
    }

    return blocks;
};
